import moment from 'moment'

export const formatDateInput = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);

  const dd = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);

  let out = dd;
  if (mm) out += '/' + mm;
  if (yyyy) out += '/' + yyyy;

  return out;
};

export const normalizeDateOnBlur = (value) => {
  const parts = value.split('/');
  if (parts.length !== 3) return value;

  let [d, m, y] = parts.map(p => p.replace(/\D/g, ''));
  if (!d && !m && !y) return '';

  d = d.padStart(2, '0').slice(0, 2);
  m = m.padStart(2, '0').slice(0, 2);
  y = y.padStart(4, '0').slice(0, 4);

  return `${d}/${m}/${y}`;
};

export const parseARDate = (ddmmyyyy = '') => {
  const [dd, mm, yyyy] = ddmmyyyy.split('/')
  if (!dd || !mm || !yyyy) return null
  return new Date(Number(yyyy), Number(mm) - 1, Number(dd))
}

export const formatDayMonth = date => {
  if (!date) return ''
  return new Date(date).toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long'
  })
}

export const formatHourMinute = date => {
  if (!date) return ''
  return new Date(date).toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })
}

export const toDateOnly = date => {
  const d = new Date(date)
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

export const toNumberSafe = (value) => {
  const safeValue = value == null ? '' : value
  const n = Number(String(safeValue).replace(/[^\d]/g, ''))
  return Number.isFinite(n) ? n : 0
}

export const buildSearchFiltersText = ({ formData = {}, clinics = [], professionals = [] }) => {
  const filters = []

  const selectedClinics = Array.isArray(formData.clinic)
    ? formData.clinic
    : formData.clinic
    ? [formData.clinic]
    : []

  if (selectedClinics.length > 0) {
    const clinicLabels = selectedClinics
      .map(value => clinics.find(c => String(c.value) === String(value))?.label || '')
      .filter(Boolean)
    if (clinicLabels.length > 0) filters.push(clinicLabels.join(', '))
  }

  if (formData.professional) {
    const professionalLabel =
      professionals.find(p => String(p.value) === String(formData.professional))?.label || ''
    if (professionalLabel) filters.push(professionalLabel)
  }

  if (formData.dateFrom && formData.dateTo) {
    filters.push(
      `${moment(formData.dateFrom).format('DD/MM/YYYY')} - ${moment(formData.dateTo).format('DD/MM/YYYY')}`
    )
  } else if (formData.dateFrom) {
    filters.push(moment(formData.dateFrom).format('DD/MM/YYYY'))
  } else if (formData.dateTo) {
    filters.push(moment(formData.dateTo).format('DD/MM/YYYY'))
  }

  if (formData.hourFrom && formData.hourTo) {
    const hourFrom =
      formData.hourFrom instanceof Date
        ? formData.hourFrom.toLocaleTimeString('es-AR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          })
        : String(formData.hourFrom)

    const hourTo =
      formData.hourTo instanceof Date
        ? formData.hourTo.toLocaleTimeString('es-AR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          })
        : String(formData.hourTo)

    filters.push(`${hourFrom} - ${hourTo}`)
  }

  return filters.join(' - ')
}

export const countSearchFilters = ({ formData = {} }) => {
  let count = 0

  const hasClinic = Array.isArray(formData.clinic)
    ? formData.clinic.length > 0
    : !!formData.clinic

  if (hasClinic) count += 1
  if (formData.professional) count += 1
  if (formData.dateFrom || formData.dateTo) count += 1
  if (formData.hourFrom && formData.hourTo) count += 1

  return count
}
